document.addEventListener("click", function (e) {
  const btn = e.target.closest(".product-column-toggle .toggle");
  if (!btn) return;

  const grid = document.querySelector("#Huratips-Loop");
  if (!grid) return;

  const cols = btn.getAttribute("data-column");
  const target = btn.getAttribute("data-target");

  // Set CSS Grid columns
  grid.style.setProperty("--wg-cols", cols);

  // Sync classes so theme logic doesn't break
  grid.classList.remove("five-column", "four-column", "three-column", "grid-list");
  if (target) grid.classList.add(target);

  // Active state
  document
    .querySelectorAll(".product-column-toggle .toggle")
    .forEach(b => b.classList.remove("active"));
  btn.classList.add("active");
});
